import { registerBlockRenderer } from "./registry";
import { MarkdownBlockView } from "./MarkdownBlock";
import { ResolutionPanelView } from "./ResolutionPanel";
import { CompareBlockView } from "./CompareBlock";
import { FreeformBlockView } from "./FreeformBlock";
import { LoomGuideBlockView } from "./LoomGuideBlock";
import { WidgetBlockView } from "./WidgetBlock";
import { MediaBlockView } from "./MediaBlock";
import { ReplayBlockView } from "./ReplayBlock";
import { LoomRunBlockView } from "./LoomRunBlock";
import { MeetingSummaryBlockView } from "./MeetingSummaryBlock";
import { NextStepsBlockView } from "./NextStepsBlock";
import { ArtifactCardView } from "./ArtifactCard";

/**
 * Register the built-in block renderers (Feature 2/3). The registrations below
 * run when this module is first imported; MessageBubble imports `getBlockRenderer`
 * from here, so registration always happens before the first block render.
 *
 * loom-guide (L2) is gated at emission (backend respond only offers it when
 * FEATURE_IA_LOOM_GUIDE is on); registering the renderer is harmless when no such
 * block arrives.
 */
registerBlockRenderer("markdown", MarkdownBlockView);
registerBlockRenderer("resolution", ResolutionPanelView);
registerBlockRenderer("compare", CompareBlockView);
registerBlockRenderer("freeform", FreeformBlockView);
registerBlockRenderer("loom-guide", LoomGuideBlockView);
registerBlockRenderer("widget", WidgetBlockView);
registerBlockRenderer("media", MediaBlockView);
// replay (FEATURE_IA_REPLAY): host-injected inline loom-session replay. Gated at
// emission (backend only injects when config.replayEnabled); registering the
// renderer is harmless when no such block arrives.
registerBlockRenderer("replay", ReplayBlockView);
// loom-run (LOOM_LIVE L-2 persistence): a "Try it yourself" run overlaid onto the
// turn from a loom-run annotation; renders the run's block snapshot on reload.
registerBlockRenderer("loom-run", LoomRunBlockView);
// meeting-summary (FEATURE_MEETING): the 5-part summary + AI-native next-steps /
// ask-this-meeting. Gated at emission (server mounts meeting routes only when the
// flag is on); registering the renderer is harmless when no such block arrives.
registerBlockRenderer("meeting-summary", MeetingSummaryBlockView);
// next-steps (FEATURE_NEXT_STEPS): post-answer suggested-next-step chips. Gated
// at emission (backend only generates when the flag is on; live over the block
// channel, reload via the next-steps annotation overlay) — registering the
// renderer is harmless when no such block arrives.
registerBlockRenderer("next-steps", NextStepsBlockView);
// artifact (FEATURE_ARTIFACTS · #7 · 7a): the in-chat card for a generated,
// persisted deliverable. Gated at emission (the create_artifact tool is only
// registered when the flag is on) — registering the renderer is harmless when no
// such block arrives. The card's "打开" is inert unless onOpenArtifact is threaded.
registerBlockRenderer("artifact", ArtifactCardView);

export { getBlockRenderer } from "./registry";
export type { BlockRendererProps } from "./registry";
